import * as actionTypes from "./action-types";
import { CookieName, getCookie } from "../utils/cookieManager";
import axios from "axios";

export const addItem = item => {
  return {
    type: actionTypes.ADD_ITEM,
    itemId: item
  };
};
export const deleteItem = item => {
  return {
    type: actionTypes.DELETE_ITEM,
    itemId: item
  };
};
export const clearCart = () => {
  return {
    type: actionTypes.CLEAR_CART
  };
};
export const reset = () => {
  return {
    type: actionTypes.RESET
  };
};

export const resetRecords = () => {
  return {
    type: actionTypes.RESET_RECORDS
  };
};

export const resetOutlets = () => {
  return {
    type: actionTypes.RESETOUTLETS
  };
};
export const toggelLoading = bool => {
  return {
    type: actionTypes.TOGGEL_LOADING,
    payload: bool
  };
};
export const statusChange = () => {
  return {
    type: actionTypes.STATUS_CHANGE
  };
};

export const notLoading = () => {
  return {
    type: actionTypes.NOT_LOADING
  };
};

export const isLoadingO = () => {
  return {
    type: actionTypes.IS_LOADING_OUTLETS
  };
};
export const setItems = (ALL, Category, Eachcat, vegMap, itemMap) => {
  return {
    type: actionTypes.SET_ITEMS,
    ALL: ALL,
    Category: Category,
    EachCat: Eachcat,
    vegMap: vegMap,
    itemMap: itemMap
  };
};

export const errorrr = () => {
  return {
    type: actionTypes.FETCHED_ITEMS_FAILS
  };
};
export const errorrrO = () => {
  return {
    type: actionTypes.FETCHED_OUTLETS_FAILS
  };
};

export const toggel = () => {
  return {
    type: actionTypes.TOGGEL
  };
};

export const initItem = (trainNO, doj, outletId, provider, stationCode) => {
  return dispatch => {
    dispatch(reset());
    axios
      .get(
        " https://securedapi.confirmtkt.com//api/platform/foodbooking/getmenuoutlet",
        {
          params: {
            trainNo: trainNO,
            doj: doj,
            outletId: outletId,
            provider: provider,

            stationCode: stationCode
          }
        }
      )
      .then(response => {
        let x = {};
        let y = [];
        let z = {};
        let a = [];
        let b = {};
        for (let i = 0; i < response.data.menu.length; i++) {
          x[response.data.menu[i].foodType] = [];
          z[response.data.menu[i].foodType] = [];
        }

        for (let i = 0; i < response.data.menu.length; i++) {
          b[response.data.menu[i].itemId] = response.data.menu[i];
          x[response.data.menu[i].foodType].push(response.data.menu[i]);
          if (response.data.menu[i].isVegeterian === true) {
            z[response.data.menu[i].foodType].push(response.data.menu[i]);
            a.push(response.data.menu[i]);
          }
        }
        // console.log(b);
        // console.log(x);
        // console.log(z);

        y.push("ALL");

        for (let key in x) {
          y.push(key);
        }

        x["ALL"] = response.data.menu;
        z["ALL"] = a;

        dispatch(setItems(response.data.menu, x, y, z, b));
      })
      .catch(error => {
        dispatch(errorrr());
      });
  };
};

export const setOutlets = (allOutlets, trainName, doj, trainNO, pnr) => {
  return {
    type: actionTypes.SET_OUTLETS,
    allOutlets: allOutlets,
    trainName: trainName,
    doj: doj,
    trainNO: trainNO,
    pnr: pnr
  };
};

export const initOutlets = (trainNo, doj, stationCode, trainName, pnr) => {
  return dispatch => {
    dispatch(resetOutlets());
    axios
      .get(
        " https://securedapi.confirmtkt.com/api/platform/foodbooking/getoutlestrain",
        {
          params: {
            trainNo: trainNo,
            doj: doj,
            stationCode: stationCode
          }
        }
      )
      .then(response => {
        console.log("trainName");
        console.log(trainName);
        dispatch(
          setOutlets(response.data.outletmap, trainName, doj, trainNo, pnr)
        );
      })
      .catch(error => {
        // console.log(error);
        dispatch(errorrrO());
      });
  };
};

export const setOrec = (current, past) => {
  return {
    type: actionTypes.SET_RECORDS,
    orderCurrent: current,
    orderPast: past
  };
};
export const isLoadingOrec = () => {
  return {
    type: actionTypes.IS_LOADING_RECORDS
  };
};

export const errorOrec = () => {
  return {
    type: actionTypes.FETCHED_RECORDS_FAILS
  };
};

export const initOrderRec = email => {
  return dispatch => {
    dispatch(resetRecords());
    let queryParams;
    console.log(email);
    if (getCookie(CookieName.USERTOKEN)) {
      queryParams = {
        authToken: getCookie(CookieName.USERTOKEN),
        provider: "RailRestro"
      };
    } else {
      console.log(email + "naruto");
      queryParams = {
        provider: "RailRestro",
        email: email
      };
    }

    console.log(queryParams);

    axios
      .get(
        " https://securedapi.confirmtkt.com/api/platform/foodbooking/getallbookings",
        {
          params: queryParams
        }
      )

      .then(response => {
        console.log(response.data);
        let oop = response.data.map(e => {
          let yr = e.deliveryDate.split("T");
          yr[0] = new Date(yr[0]);
          yr[0] = yr[0].getTime();
          let xr = { ...e, Tstamp: yr[0] };
          return xr;
        });

        oop.sort((b, a) => (a.Tstamp > b.Tstamp ? 1 : -1));

        let dateObj = new Date();
        let month = dateObj.getUTCMonth() + 1; //months from 1-12
        let day = dateObj.getUTCDate();
        let year = dateObj.getUTCFullYear();

        let today = year + "/" + month + "/" + day;

        today = new Date(today);
        today = today.getTime();

        let current = oop.filter(e => {
          // let z = e.deliveryDate.split("T");
          // z[0] = new Date(z[0]);

          // z[0] = z[0].getTime();

          if (today <= e.Tstamp) {
            return true;
          } else {
            // console.log(e.deliveryDate);
            return false;
          }
        });

        let past = oop.filter(e => {
          // let z = e.deliveryDate.split("T");
          // z[0] = new Date(z[0]);
          // z[0] = z[0].getTime();

          if (today > e.Tstamp) return true;
          else return false;
        });

        dispatch(setOrec(current, past));
      })
      .catch(error => {
        dispatch(errorOrec());
      });
  };
};

export const initByPnr = pnr => {
  return dispatch => {
    dispatch(resetOutlets());
    console.log("init");
    console.log(pnr);
    axios
      .get("https://api.confirmtkt.com/api/pnr/pnrfoodbooking", {
        params: {
          pnr: pnr
        }
      })
      .then(response => {
        if (response.data) {
          let trainNO = response.data.TrainNo;
          let doj = response.data.Doj;
          let trainName = response.data.TrainName;
          let stationCode = response.data.BoardingPoint;
          console.log("trainNo" + trainNO + "-----");
          dispatch(initOutlets(trainNO, doj, stationCode, trainName, pnr));
        } else {
          console.log("null");
          dispatch(errorrrO());
        }
      })
      .catch(error => {
        console.log(error);
        dispatch(errorrrO());
      });
  };
};
